// Core
import styled from 'styled-components';

export const CreateContainer = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
`;

export const FileUploadContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const CoverContainer = styled.div`
  display: flex;
  width: 100%;
  padding-top: 24px;
`;

export const ActionsUploadContainer = styled.div`
  display: flex;
  max-width: max-content;
  padding-bottom: 20px;
  gap: 10px;
  padding-top: 20px;
`;

export const FormFieldsContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

export const TechnicalInfoContainer = styled.div`
  padding-top: 24px;
`;

export const OCPServerContainer = styled.div`
  padding-top: 20px;
`;
